import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getFunctions } from "firebase/functions";

// Coloca aqui as tuas credenciais
const firebaseConfig = {
  apiKey: "AIzaSyBdiTlTNNWxpjW10BtYmBR80FePFI_MB-8",
  authDomain: "spp-app-05082025.firebaseapp.com",
  databaseURL: "https://spp-app-05082025-default-rtdb.firebaseio.com",
  projectId: "spp-app-05082025",
  storageBucket: "spp-app-05082025.firebasestorage.app",
  messagingSenderId: "451837741750",
  appId: "1:451837741750:web:96e693549a456882bd7417",
  measurementId: "G-BKWCW96ZW8"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);
export const functions = getFunctions(app);